import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrFuelPage } from './klmr-fuel';

@NgModule({
  declarations: [
    KlmrFuelPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrFuelPage),
  ],
})
export class KlmrFuelPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-fuel/klmr-fuel.module.ts